<template>
  <div class="min-h-screen flex flex-col items-center justify-center bg-[#0E171F] text-white px-4">
    <div class="w-full max-w-md p-6 bg-[#1C2834] rounded-lg shadow-lg">
      <h1 class="text-2xl font-semibold text-center mb-6">Scanner de QR Code</h1>

      <!-- Zone caméra -->
      <div
        class="relative w-full aspect-square bg-black rounded-lg overflow-hidden border-2 border-[#e6204b] flex items-center justify-center mb-6">
        <div id="reader" class="w-full h-full"></div>

        <div v-if="isScanning" class="absolute inset-0 flex items-center justify-center bg-opacity-50 bg-black">
          <div class="w-16 h-16 border-4 border-t-4 border-[#e6204b] border-solid rounded-full animate-spin"></div>
        </div>
      </div>

      <!-- Zone message -->
      <div class="text-center">
        <p v-if="qrCodeMessage" :class="qrCodeValid ? 'text-green-400' : 'text-[#e6204b]'"
          class="font-medium transition-all duration-300">
          {{ qrCodeMessage }}
        </p>
        <p v-else class="text-gray-500">Aucun QR code scanné</p>
      </div>

      <!-- Bouton pour recommencer -->
      <div v-if="qrCodeMessage" class="mt-6 flex justify-center">
        <button @click="restartScanning"
          class="px-6 py-2 bg-[#e6204b] hover:bg-red-700 text-white font-medium rounded-lg transition">
          Recommencer
        </button>
      </div>
    </div>

    <!-- Modal de validation -->
    <div v-if="showModal" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div class="bg-[#1C2834] rounded-lg p-6 max-w-md text-center shadow-xl">
        <h2 class="text-2xl font-semibold text-green-400 mb-4">Ticket Valide 🎉</h2>
        <p class="text-white mb-6">Le ticket scanné est valide. Bienvenue !</p>
        <button @click="closeModal"
          class="px-6 py-2 bg-[#950C16] hover:bg-red-700 text-white font-medium rounded-lg transition">
          OK
        </button>
      </div>
    </div>

    <div v-if="showerrorModal" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div class="bg-[#1C2834] rounded-lg p-6 max-w-md text-center shadow-xl">
        <h2 class="text-2xl font-semibold text-green-400 mb-4">qrcode non valide ou deja utilise</h2>
        <p class="text-white mb-6">Le ticket scanné n'est pas acceptable. veuillez refaire le scan !</p>
        <button @click="closeModal"
          class="px-6 py-2 bg-[#950C16] hover:bg-red-700 text-white font-medium rounded-lg transition">
          OK
        </button>
      </div>
    </div>


  </div>
</template>
<script>
import { Html5Qrcode } from "html5-qrcode";

export default {
  data() {
    return {
      qrCodeMessage: "",
      qrCodeValid: false,
      html5QrCode: null,
      isScanning: false,
      showModal: false,
      showerrorModal: false
    };
  },
  mounted() {
    if(localStorage.getItem("jwtToken")){
      this.initializeCamera();
    }else{
      this.$router.back()
    }
  },
  beforeUnmount() {
    this.stopCamera()
  },
  methods: {
    initializeCamera() {
      const cameraConfig = { fps: 10, qrbox: { width: 300, height: 200 } };
      this.html5QrCode = new Html5Qrcode("reader");

      this.html5QrCode
        .start(
          { facingMode: "environment" },
          cameraConfig,
          (decodedText) => this.handleQRCodeScanned(decodedText)
        )
        .catch((err) => {
          console.error("Erreur d'activation de la caméra :", err);
          this.qrCodeMessage = "Impossible d'activer la caméra.";
        });
    },
    handleQRCodeScanned(decodedText) {
      this.isScanning = true;

      try {
        const parsedData = JSON.parse(decodedText);
        if (parsedData.name && parsedData.email) {
          this.qrCodeData = parsedData;
          let data = new FormData();
          data.append("name", this.qrCodeData.name);
          data.append("email", this.qrCodeData.email);

          console.dir(data)
          this.axios
            .post(this.$store.state.api + "/verifiedCustomer", data)
            .then(({ data }) => {
              this.qrCodeValid = data;
              this.qrCodeMessage = "QR code scanné avec succès.";
              this.showModal = true; // Afficher le modal de validation
              this.stopCamera();
              this.restartScanning
            })
            .catch((error) => {
              this.showerrorModal = true
              console.log(error);
            });
        } else {
          this.qrCodeMessage = "QR code non valide.";
          this.showModal = true;
        }
      } catch (error) {
        this.qrCodeData = decodedText;
        this.qrCodeMessage =
          "QR code scanné avec succès, mais le contenu n'est pas structuré.";
        this.qrCodeValid = false;
        this.showModal = true; 

      }

      this.isScanning = false;
    },
    stopCamera() {
      if (this.html5QrCode) {
        this.html5QrCode.stop().then(() => {
          console.log("Caméra arrêtée.");
        });
      }
    },
    closeModal() {
      this.showModal = false; // Fermer le modal
      this.qrCodeValid = true;
    },
    restartScanning() {
      this.qrCodeMessage = "";
      this.qrCodeValid = false;
      this.showModal = false;
      this.initializeCamera(); // Redémarrer le scanner
    },
  },
  onBeforeUnmount() {
    this.stopCamera();
  },
};
</script>
